import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class CompanyEmailTemplate extends DomainObject {
  emailContentEn;
  emailContentFr;
  emailType;

  constructor(other) {
    super();

    makeObservable(this, {
      emailContentEn: observable,
      emailContentFr: observable,
      emailType: observable
    });

    this.merge(other);
  }
}

export default CompanyEmailTemplate;
